/* SmartRx cart presentation only. Globo remains the pricing authority. */
const SRX_CART_PRICES = {"Progressive Lens Options":{"Basic Progressive":6997,"Advanced Progressive":9997},"Lens Package":{"1.6 Index High-Impact Resistant Safety Lenses":9175,"1.59 Index Polycarbonate High-Impact Resistant Safety Lenses":9475,"1.67 Index High-Impact Resistant Safety Lenses":10675,"1.74 Index Thinnest Available Lenses":12975},"Lens Features":{"Photochromic lenses":7497,"Clear - lenses for everyday use (Free)":0,"Photochromic - darken up to 70% when outdoors, fade back to clear indoors":7497,"Photochromic – TRANSITIONS® GEN S™":13497,"Polarized sun lenses":6525,"Sunglasses - color lenses":4075},"Additional coatings":{"Super Hydrophobic":1399,"Anti-Reflective":2495,"Blue Light":2575,"Blue Light Blocking":2575}};
(() => {
  if (customElements.get('srx-cart-summary')) return;
  const node = (tag, className, text) => {
    const el = document.createElement(tag);
    if (className) el.className = className;
    if (text !== undefined) el.textContent = text;
    return el;
  };
  const shortName = value => String(value)
    .replace(' Index High-Impact Resistant Safety Lenses', ' index · impact resistant')
    .replace(' Index Polycarbonate High-Impact Resistant Safety Lenses', ' polycarbonate · impact resistant')
    .replace(' Index Thinnest Available Lenses', ' index · ultra thin')
    .replace('Clear - lenses for everyday use (Free)', 'Clear lenses')
    .replace('Photochromic - darken up to 70% when outdoors, fade back to clear indoors', 'Photochromic lenses')
    .replace('Photochromic – TRANSITIONS® GEN S™', 'Transitions® GEN S™')
    .replace('Sunglasses - color lenses', 'Tinted sun lenses');

  customElements.define('srx-cart-summary', class extends HTMLElement {
    connectedCallback() {
      if (this.rendered) return;
      try {
        const data = JSON.parse(this.querySelector('[data-srx-cart-data]').textContent);
        const copy = JSON.parse(this.querySelector('[data-srx-cart-copy]').textContent);
        const pairs = Array.isArray(data.properties) ? data.properties : Object.entries(data.properties || {});
        const entities = {'&quot;':'"', '&#34;':'"', '&#39;':"'", '&lt;':'<', '&gt;':'>', '&amp;':'&'};
        const props = Object.fromEntries(pairs.map(([key,value]) => [key, typeof value === 'string' ? value.replace(/&(?:quot|amp|lt|gt);|&#(?:34|39);/g, entity => entities[entity]) : value]));
        if (String(props._has_gpo) !== '1766375') return;
        const charges = JSON.parse(props._gpo_addon_products || '[]');
        // Do not invent a component price when the app format/currency differs.
        if (data.currency !== 'USD' || !Array.isArray(charges) || charges.some(c => c.t !== 'price' || Number(c.i) !== data.id || Number(c.q) !== 1 || !Number.isFinite(Number(c.p)) || Number(c.p) < 0)) return;
        const actual = charges.map(c => Math.round(Number(c.p) * 100));
        const addonTotal = actual.reduce((sum, n) => sum + n, 0);
        if (!Number.isInteger(data.original) || data.original < addonTotal) return;
        const rows = [];
        let known = true;
        for (const [field, options] of Object.entries(SRX_CART_PRICES)) {
          if (!props[field]) continue;
          const values = Object.hasOwn(options, props[field]) ? [props[field]] : String(props[field]).split(',').map(s => s.trim());
          for (const value of values) {
            if (!Object.hasOwn(options, value)) { known = false; continue; }
            rows.push({field, value, price: options[value]});
          }
        }
        const expected = rows.filter(r => r.price > 0).map(r => r.price).sort((a,b) => a-b);
        const recorded = [...actual].sort((a,b) => a-b);
        const exact = known && JSON.stringify(expected) === JSON.stringify(recorded);
        const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:data.currency}).format(cents / 100);
        const content = node('div', 'srx-cart-configuration');
        content.append(node('p', 'srx-cart-caption', copy.each));
        const breakdown = node('dl', 'srx-cart-breakdown');
        const line = (label, price, note) => {
          const row = node('div', 'srx-cart-price-row');
          const term = node('dt', '', label);
          if (note) term.append(node('small', '', note));
          row.append(term, node('dd', price === 0 ? 'srx-cart-included' : '', price === 0 ? copy.included : money(price)));
          breakdown.append(row);
        };
        line(copy.frame, data.original - addonTotal, data.variant === 'Default Title' ? '' : data.variant);
        const noRx = props['Choose Your Lenses'] === 'No Prescription';
        if (noRx) line(copy.standard, 0);
        else if (props['Vision Needs'] && props['Vision Needs'] !== 'Progressive') {
          line(props['Vision Needs'] === 'Reading' ? copy.reading : copy.single, 0);
        }
        const color = Object.entries(props).find(([key,value]) => /color/i.test(key) && value)?.[1];
        if (exact) {
          for (const row of rows) line(shortName(row.value), row.price, row.field === 'Lens Features' ? color : '');
        } else {
          // Legacy/changed Globo options retain the accurate aggregate and complete details.
          line(copy.lens_total, addonTotal);
        }
        if (data.final < data.original) line(copy.savings, data.final - data.original);
        content.append(breakdown);
        if (!noRx || !exact) {
          const details = node('details', 'srx-cart-fold');
          const summary = node('summary', '', exact ? copy.prescription : copy.selections);
          const method = props['Add Your Prescription'] || '';
          const status = /UPLOAD/.test(method) ? copy.uploaded : /LATER/.test(method) ? copy.later : /MANUALLY/.test(method) ? copy.manual : '';
          if (status && exact) summary.append(node('small', '', status));
          details.append(summary);
          const facts = node('dl', 'srx-cart-facts');
          const selected = new Set(['Choose Your Lenses','Vision Needs',...Object.keys(SRX_CART_PRICES)]);
          for (const [key,value] of Object.entries(props)) {
            if (key.startsWith('_') || !value || (exact && (selected.has(key) || /color/i.test(key) || key === 'PD Type'))) continue;
            const row = node('div');
            const label = key.replace('Add Your Prescription', copy.prescription).replace('Single PD', copy.pd).replace('-right', ' · OD').replace('-left', ' · OS');
            const term = node('dt', '', label);
            const description = node('dd');
            if (/^https:\/\/.*\/uploads\//.test(String(value))) {
              const link = node('a', '', copy.view_file);link.href=value;link.target='_blank';link.rel='noopener';description.append(link);
            } else description.textContent = key === 'Add Your Prescription' && status ? status : value;
            row.append(term, description);facts.append(row);
          }
          details.append(facts);content.append(details);
        }
        const total = node('div', 'srx-cart-line-total');
        const label = node('span', '', copy.total);
        if (data.quantity > 1) label.append(node('small', '', `${data.quantity} ${copy.quantity} · ${money(data.final)} ${copy.each}`));
        total.append(label, node('strong', '', money(data.total)));content.append(total);
        this.querySelector('[data-srx-cart-fallback]').replaceWith(content);
        this.closest('.cart-item')?.classList.add('srx-cart-enhanced');
        this.dataset.verified = String(exact);
        this.rendered = true;
      } catch (_) {
        // The native price and accessible property disclosure remain available.
      }
    }
  });
})();
